export const handleChangeDataSearchAutoComplete = (name, value) => ({
    type: 'CHANGE_DATA_SEARCH_AUTOCOMPLETE', name, value
});